import { fetchAuthenticatedUser,appContext } from "@redux/actionCreators/UserActions/loginActions";

const FORM_DATA = 'form-data';
const METHOD_GET = 'GET';
const METHOD_POST = 'POST';
const METHOD_PUT = 'PUT';
const METHOD_PATCH = 'PATCH';
const METHOD_DELETE = 'DELETE';
const BODY_METHODS = [METHOD_POST,METHOD_PUT,METHOD_PATCH];
const defaultOpt = {
  method:METHOD_GET,
  mode: "cors",
  //credentials: "include",
  headers: {
      "Content-Type": "application/json; charset=utf-8"
  }
}

const defaultPostOpt = {
    ...defaultOpt,
    method: METHOD_POST
}

const defaultFormDataOpt = {
  ...defaultPostOpt,
  bodyType:FORM_DATA,
  headers: {
    "Content-Type": ""
  }
}
const mergeOptions = (dOpt,options)=>
{
  return {...dOpt,...options,headers:{...dOpt.headers,...(options.headers || {})}};
}
export const RESPONSE_TYPES = {BLOB:'blob',JSON:'json',TEXT:'text'}
export const apiOptions = ({clinicId,headers={},excludeClinicHeader,excludeToken,...otherOpts}={}) => async dispatch => {
  const { token } = excludeToken?{}:(await dispatch(fetchAuthenticatedUser()));
  const cid = clinicId || appContext.cid;
  const additionalHeaders = cid && !excludeClinicHeader? clinicIdHeader(cid,headers):headers;
  const options = {otherOpts, headers: { ...(excludeToken?{}:{Authorization: token}), ...additionalHeaders } };
  
  return options;
};

export const clinicIdHeader = (clinicId,extraData={}) => ({"clinic-id": clinicId,...extraData});

const METHODS = {GET:'get',POST:'post',DELETE:'delete',PUT:'put',PATCH:'patch'};
export class CustomAPI {
    static API_METHODS = METHODS
    static api = ({method=CustomAPI.API_METHODS.GET,apiUrl,params={},body=params,options,...opts})=> async dispatch =>{
      const {headers,otherOpts} = await dispatch(apiOptions(opts));
      if(!CustomAPI[method]){
        throw {error:'CustomAPI method not implemented',message:'CustomAPI method not implemented'}
      }
      return await CustomAPI[method](apiUrl,{params,headers,body,options,...otherOpts})
    }
    static async delete(url,{params={},headers={},options={},...others}){
      //options = {...options,method:METHOD_DELETE};
      return CustomAPI.get(url,{params,headers,options:{...mergeOptions(defaultOpt,options),method:METHOD_DELETE},urlParams:true,...others});
    }

    static async formData(url,{params={},body={},headers={},options={},...others}){
      //options = {...options,method:METHOD_POST};
      return CustomAPI.post(url,{params,headers,body,options:{...mergeOptions(defaultFormDataOpt,options),method:METHOD_POST},...others});
    }

    static async get(url,{params={},headers={},options={},...others}){
      return await CustomAPI._send(url,{params,headers,options:{...mergeOptions(defaultOpt,options)},...others});
    }

    static async put(url,{params={},body={},headers={},options={},...others}){
      options = {...options,method:METHOD_PUT};
      return CustomAPI.post(url,{params,body,headers,options:{...options,method:METHOD_PUT},...others});
    }

    static async patch(url,{params={},body={},headers={},options={},...others}){
      options = {...options,method:METHOD_PATCH};
      return CustomAPI.post(url,{params,body,headers,options:{...options,method:METHOD_PUT},...others});
    }
    
    static async post(url,{params={},body={},headers={},options={},...others}){
        return await CustomAPI._send(url,{params,body,headers,options:{...mergeOptions(defaultPostOpt,options)},...others});;
    }
    
    static async _send(url,{params,headers,body,urlParams,responseType=RESPONSE_TYPES.JSON,options={method:METHOD_GET,mode: "cors",}}){
        let paramsToBody = BODY_METHODS.includes(options.method);
        params = params || {};
        if(options.bodyType == FORM_DATA){
          delete options.headers['Content-Type'];
          const fields = options.fields || Object.keys(body);
          options.fields && (delete options.fields);
          let formData = new FormData();
          fields.forEach(k=>{
            formData.append(k,body[k]);
          })
          options['body'] = formData;
        } else if(paramsToBody){
          options['body'] = JSON.stringify(body);
        }

        options.headers = {...options.headers,...headers};

        if(urlParams){
          const qparam = Object.keys(params).map(key => {
            let v = params[key];
            return v!=undefined? (key+'='+v):'';
          }).filter(x => x.length > 0).join('&');
  
          url = url + (qparam.length?((url.includes('?')?'&':'?') + qparam):'');
        }

        let data = await (await (fetch(url,options)
        .then(res => {
          let contentType = res.headers.get("content-type");
          let jres = res;
          if(contentType && contentType.includes("application/json")) {
            jres = res.json();
          }
          else if(responseType == 'blob' && res.blob){
            jres = res.blob();
          }
          else if(res.text){
            jres = res.text();
          }          
          
          if(res.ok){
            return jres;            
          }
          else{
            //return jres.then(err => {throw err;});
            return jres.then(Promise.reject.bind(Promise));
          }
          
        })
        .catch(err => {
          console.log('Error in data service: ', err);
          throw err;
        })
        .finally(()=>{
        })
      ))
      return data
    }
}

export default CustomAPI